import SuggestedFilterChips, {
  type SuggestedFilterChipItem
} from '@/common/SuggestedFilterChips';
import FilterMenuChip from '@/srp/FilterMenuChip';
import { useIsDesktop } from '~/context/common/DeviceContext';

type OwnProps = {
  filterMenuChipTestId: string;
  isLoading: boolean;
  items: Array<SuggestedFilterChipItem>;
  showCounts: boolean;
};

export default function TwoRowSuggestedFilters({
  filterMenuChipTestId,
  isLoading,
  items,
  showCounts
}: OwnProps) {
  const isDesktop = useIsDesktop();

  if (isDesktop) {
    return (
      <div className="flex flex-1 flex-wrap items-center gap-md overflow-hidden">
        <SuggestedFilterChips
          isLoading={isLoading}
          items={items}
          showCounts={showCounts}
        />
      </div>
    );
  }

  return (
    <div className="min-w-0 flex-1 overflow-hidden">
      <div className="no-scrollbar flex overflow-x-auto">
        <SuggestedFilterChips
          isLoading={isLoading}
          items={items}
          layout="twoRow"
          leadingElement={
            <FilterMenuChip
              className="shrink-0"
              dataAnalyticsAttributes={JSON.stringify({
                item: 'open modal button',
                source: 'page'
              })}
              testId={filterMenuChipTestId}
            />
          }
          showCounts={showCounts}
        />
      </div>
    </div>
  );
}
